export default __webpack_public_path__ + "static/media/hero-desktop-safari-ES.4dd8ace9.png";